import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconArchiveSvg } from "./IconArchiveSvg.mjs";
const IconArchive = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconArchiveSvg, ...iconProps });
};
export {
  IconArchive
};
